const DEFAULT_ERROR_MESSAGE = 'The api key was not found';

export default class ApiKeyWasNotFoundException extends Error {
  constructor(message: string = DEFAULT_ERROR_MESSAGE) {
    super(message);
  }
}
